import { STATUS_LABEL } from "@/lib/api";

const STYLES = {
  completed: "border-emerald-500/40 text-emerald-300 bg-emerald-500/10",
  cancelled: "border-red-500/40 text-red-300 bg-red-500/10",
  searching: "border-amber-500/40 text-amber-300 bg-amber-500/10",
  awaiting_payment: "border-zinc-600 text-zinc-400",
  awaiting_zelle: "border-amber-500/40 text-amber-300 bg-amber-500/10",
  failed: "border-red-500/40 text-red-300 bg-red-500/10",
  paid: "border-emerald-500/40 text-emerald-300 bg-emerald-500/10",
  refunded: "border-sky-500/40 text-sky-300 bg-sky-500/10",
  approved: "border-emerald-500/40 text-emerald-300 bg-emerald-500/10",
  pending: "border-amber-500/40 text-amber-300 bg-amber-500/10",
  suspended: "border-red-500/40 text-red-300 bg-red-500/10",
};

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${STYLES[status] || "border-blue-500/40 text-blue-300 bg-blue-500/10"}`}>
    {STATUS_LABEL[status] || (status || "—").replace(/_/g, " ")}
  </span>
);
